import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

import { Field, Fields, FieldArray } from 'redux-form';

import TextField from 'components/fields/TextField';
import Button from 'components/common/Button';
import SelectAutosuggestField from 'components/fields/SelectAutosuggestField';
import IconButton from 'components/common/IconButton';
import IconPlus from 'components/icons/IconPlus';
import IconPen from 'components/icons/IconPen';
import ReportStructureCreateEditDialog from 'components/reports/ReportStructureCreateEditDialog';
import ReportNameCreateDialog from 'components/reports/ReportNameCreateDialog';

import * as validate from 'utils/validate';

import { requestSearchReportStructures, requestFetchReportStructures } from 'redux/modules/reportStructures';

import ReportsCreateEditStructures from './ReportsCreateEditStructures';
import ReportsCreateEditFormEmpty from './ReportsCreateEditFormEmpty';
import ReportsCreateEditFormSection from './ReportsCreateEditFormSection';
import ReportsCreateEditFormStructureField from './ReportsCreateEditFormStructureField';

const styles = theme => ({
  root: {
    position: 'relative',
    boxSizing: 'border-box',
    height: '100%',
    padding: '24px 40px',
    [theme.breakpoints.down('sm')]: {
      padding: 8,
    },
  },
  header: {
    paddingBottom: 24,
    marginBottom: 12,
    borderBottom: `1px solid ${theme.palette.primary.A400}`,
    [theme.breakpoints.down('sm')]: {
      paddingBottom: 8,
    },
  },
  gridButtons: {
    marginTop: 30,
  },
  gridItemShrink: {
    flexShrink: '1',
  },
  gridError: {
    marginTop: 24,
  },
  iconButton: {
    margin: -4,
    marginRight: -15,
    position: 'relative',
    verticalAlign: 'bottom',
  },
  iconPlus: {
    width: 14,
    height: 14,
    color: theme.palette.primary[500],
  },
  iconPen: {
    width: 14,
    height: 14,
    color: theme.palette.primary[500],
  },
});

class ReportsCreateEditFormMain extends Component {
  constructor(props) {
    super(props);

    this.state = {
      reportStructureCreateEditDialogOpen: false,
      reportStructureVariant: 'create',
      reportNameCreateDialogOpen: false,
    };

    this.onReportStructureCreateButtonClick = this.onReportStructureCreateButtonClick.bind(this);
    this.onReportStructureEditButtonClick = this.onReportStructureEditButtonClick.bind(this);
    this.onReportStructureCreateEditDialogClose = this.onReportStructureCreateEditDialogClose.bind(this);
    this.onReportTemplateSave = this.onReportTemplateSave.bind(this);
    this.onReportNameCreateDialogClose = this.onReportNameCreateDialogClose.bind(this);
    this.onReportNameCreateDialogSubmitSuccess = this.onReportNameCreateDialogSubmitSuccess.bind(this);
  }

  onReportStructureCreateButtonClick() {
    this.setState({
      reportStructureCreateEditDialogOpen: true,
      reportStructureVariant: 'create',
    });
  }
  onReportStructureEditButtonClick() {
    this.setState({
      reportStructureCreateEditDialogOpen: true,
      reportStructureVariant: 'edit',
    });
  }

  onReportStructureCreateEditDialogClose() {
    this.setState({ reportStructureCreateEditDialogOpen: false });
  }

  onReportTemplateSave() {
    this.setState({ reportNameCreateDialogOpen: true });
  }

  onReportNameCreateDialogClose() {
    this.setState({ reportNameCreateDialogOpen: false });
  }

  onReportNameCreateDialogSubmitSuccess(values) {
    const { change, handleSubmit, onSubmitCustom } = this.props;
    change('Name', values.Name); 
    setTimeout(() => {
      handleSubmit(onSubmitCustom(false))();
    }, 500);
  }

  render() {
    const {
      handleSubmit,
      onSubmitCustom,
      array,
      change,
      pristine,
      submitting,
      variant,
      filters,
      actions,
      classes,
      onReportGenerate,
    } = this.props;

    const { reportStructureCreateEditDialogOpen, reportStructureVariant, reportNameCreateDialogOpen } = this.state;

    return (
      <Paper className={classes.root}>
        {(variant === 'create' || variant === 'edit') &&
          <Fragment>
            <div className={classes.header}>
              <Typography
                variant="subheading"
                color="secondary"
              >
                Report Settings
              </Typography>
            </div>
            <Grid
              container
              alignItems="flex-end"
              spacing={16}
              wrap="nowrap"
            >
              <Grid
                className={classes.gridItemShrink}
                item
                xs={12}
              >
                <Field
                  label="Columns Template"
                  name="Default Report Structure Name"
                  id="Default Report Structure Name"
                  autosuggestFieldName="Patient Name"
                  fieldArrayName="Patient"
                  placeholder="Search saved columns templates"
                  component={SelectAutosuggestField}
                  fullWidth
                  renderSuggestionContent={suggestion => suggestion.Name}
                  renderInputContent={suggestion => suggestion.Name}
                  onSuggestionSelected={(suggestion) => {
                    change('Default Report Structure ID', suggestion.ID);
                    change('Selected Default Report Structure Name', suggestion.Name);
                    return suggestion.Name;
                  }}
                  fetchSuggestions={({ value, limit, offset }) => 
                    value.length > 0
                      ? requestSearchReportStructures({
                        filters: [{
                          name: 'Name',
                          operation: 'startswith',
                          val: value,
                          case_sensitivity: false,
                        }],
                        limit,
                        offset,
                      }).then(res => res.data,
                        (err) => {
                          if (err.data.error === 'Need authorisation') {
                            actions.accountLoginFail();
                          }
                          return err;
                        })
                      : requestFetchReportStructures({
                        limit,
                        offset,
                      }).then(res => res.data,
                        (err) => {
                          if (err.data.error === 'Need authorisation') {
                            actions.accountLoginFail();
                          }
                          return err;
                        })
                  }
                  onListAdornmentClick={this.onReportStructureCreateButtonClick}
                  listAdornmentText="Create New Columns Structure"
                />
              </Grid>
              <Grid item>
                {filters['Report Structure ID'] ? (
                  <IconButton
                    className={classes.iconButton}
                    onClick={this.onReportStructureEditButtonClick}
                    tooltipContent="Edit Selected Columns Structure Template"
                  >
                    <IconPen className={classes.iconPen} />
                  </IconButton>
                ) : (
                  <IconButton
                    className={classes.iconButton}
                    onClick={this.onReportStructureCreateButtonClick}
                    tooltipContent="Create New Columns Structure Template"
                  >
                    <IconPlus className={classes.iconPlus} />
                  </IconButton>
                )}
              </Grid>
            </Grid>
            <ReportStructureCreateEditDialog
              open={reportStructureCreateEditDialogOpen}
              form={filters['Report Structure ID'] && reportStructureVariant === 'edit'
                ? `${filters['Report Structure ID']}-reportStructureEditForm` : 'reportStructureCreateForm'}
              {...filters['Report Structure ID'] && reportStructureVariant === 'edit' ? {
                ID: filters['Report Structure ID'],
              } : {}}
              onClose={this.onReportStructureCreateEditDialogClose}
              onDelete={() => {
                if (variant === 'create') {
                  change('Default Report Structure ID', null);
                  change('Default Report Structure Name', null);
                  change('Selected Default Report Structure Name', null);
                }
              }}
              onSubmitSuccess={(values) => {
                if (reportStructureVariant === 'create') {
                  change('Default Report Structure ID', values.ID);
                  change('Default Report Structure Name', values.Name);
                  change('Selected Default Report Structure Name', values.Name);
                }
              }}
            />
          </Fragment>      
        }
        {filters['Report Order Line Rejected'] &&
          <ReportsCreateEditFormSection
            label="Rejected"
            filters={filters}
            onRemove={() => {
              change('Not Rejected', true);
              change('Rejected', false);
            }}
          />
        }
        <Fields
          names={[
            'Date of Creation From',
            'Date of Creation To',
          ]}
          label="Date of Creation from/to"
          component={ReportsCreateEditFormSection}
          separator=" - "
          onRemove={() => {
            change('Date of Creation From', '');
            change('Date of Creation To', '');
          }}
        />
        <Fields
          names={[
            'Date of Service From',
            'Date of Service To',
          ]}
          label="Date of Service from/to"
          component={ReportsCreateEditFormSection}
          separator=" - "
          onRemove={() => {
            change('Date of Service From', '');
            change('Date of Service To', '');
          }}
        />
        <Fields
          names={[
            'Reimbs Date From',
            'Reimbs Date To',
          ]}
          label="Reimbs Date from/to"
          component={ReportsCreateEditFormSection}
          separator=" - "
          onRemove={() => {
            change('Reimbs Date From', '');
            change('Reimbs Date To', '');
          }}
        />
        {filters['Claim Date of Creation From']
          && filters['Claim Date of Creation To'] &&
          <Fields
            names={[
              'Claim Date of Creation From',
              'Claim Date of Creation To',
            ]}
            label="Claim Date of Creation from/to"
            component={ReportsCreateEditFormSection}
            separator=" - "
            onRemove={() => {
              change('Claim Date of Creation From', '');
              change('Claim Date of Creation To', '');
            }}
          />
        }
        {filters['Step Number']
          && filters['Step Value'] &&
          <Fields
            names={[
              'Step Number',
              'Step Value',
            ]}
            label="In last"
            component={ReportsCreateEditFormSection}
            separator=" "
            onRemove={() => {
              change('Step Number', '');
              change('Step Value', 'Week');
            }}
          />
        }
        <FieldArray
          name="Workflow State"
          label="Workflow Category"
          component={ReportsCreateEditFormSection}
          separator=", "
          onRemove={() => {
            array.removeAll('Workflow State');
          }}
        />
        <FieldArray
          name="Workflow Status"
          label="Status"
          separator=", "
          component={ReportsCreateEditFormSection}
          onRemove={() => {
            array.removeAll('Workflow Status');
          }}
        />
        <FieldArray
          name="HCPC Code"
          label="HCPCS Code"
          component={ReportsCreateEditFormSection}
          separator=", "
          onRemove={() => {
            array.removeAll('HCPC Code');
          }}
        />
        <FieldArray
          name="Report Order Line Type"
          label="Type"
          component={ReportsCreateEditFormSection}
          separator=", "
          onRemove={() => {
            array.removeAll('Report Order Line Type');
          }}
        />
        <FieldArray
          name="Assigned User"
          label="Users"
          component={ReportsCreateEditFormSection}
          separator=", "
          onRemove={() => {
            array.removeAll('Assigned User');
          }}
        />
        <FieldArray
          name="Prescriber"
          label="Prescriber"
          component={ReportsCreateEditFormSection}
          separator=", "
          onRemove={() => {
            array.removeAll('Prescriber');
          }}
        />
        <FieldArray
          name="Sales Representative"
          label="Sales Person"
          component={ReportsCreateEditFormSection}
          separator=", "
          onRemove={() => {
            array.removeAll('Sales Representative');
          }}
        />
        <FieldArray
          name="Referral Source"
          label="Referral Source"
          component={ReportsCreateEditFormSection}
          separator=", "
          onRemove={() => {
            array.removeAll('Referral Source');
          }}
        />
        <FieldArray
          name="Insurance Info"
          label="Payer"
          component={ReportsCreateEditFormSection}
          separator=", "
          onRemove={() => {
            array.removeAll('Insurance Info');
          }}
        />
        <FieldArray
          name="Patient"
          label="Patients"
          component={ReportsCreateEditFormSection}
          separator=", "
          onRemove={() => {
            array.removeAll('Patient');
          }}
        />
        <FieldArray
          name="Check Book Sheet"
          label="Check Numbers"
          component={ReportsCreateEditFormSection}
          separator=", "
          onRemove={() => {
            array.removeAll('Check Book Sheet');
          }}
        />
        {(variant === 'edit'
          || (['create', 'claim'].indexOf(variant) !== -1 && Object.keys(filters).length > 0)) ? (
            <Grid
              className={classes.gridButtons}
              container
              alignItems="center"
              justify="space-between"
              spacing={24}
            >
              <Grid item>
                <Grid
                  container
                  alignItems="center"
                  spacing={24}
                >
                  {variant !== 'claim' &&
                    <Grid item>
                      <Button
                        variant="raised"
                        disabled={pristine || submitting}
                        onClick={() => {
                          if (variant === 'edit') {
                            handleSubmit(onSubmitCustom(false))();
                          } else {
                            this.onReportTemplateSave();
                          }
                        }}
                      >
                        {variant === 'create' && 'Save As Template'}
                        {variant === 'edit' && 'Save Changes'}
                      </Button>
                      <ReportNameCreateDialog
                        title="Save New Report Template"
                        form="Report-Name-Create"
                        open={reportNameCreateDialogOpen}
                        onClose={this.onReportNameCreateDialogClose}
                        onSubmitSuccess={this.onReportNameCreateDialogSubmitSuccess}
                      />
                    </Grid>
                  }
                  <Grid item>
                    <Button
                      variant="raised"
                      color="primary"
                      onClick={onReportGenerate}
                    >
                      Generate
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          ) : (
            <ReportsCreateEditFormEmpty
              variant={variant}
              onReportGenerate={onReportGenerate}
            />
          )}
      </Paper>
    );
  }
}

ReportsCreateEditFormMain.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  onSubmitCustom: PropTypes.func.isRequired,
  array: PropTypes.shape({
    removeAll: PropTypes.func.isRequired,
  }).isRequired,
  change: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  variant: PropTypes.oneOf(['create', 'edit', 'claim', 'insurance']).isRequired,
  filters: PropTypes.shape({
    Name: PropTypes.string,
    'Date of Service From': PropTypes.string,
    'Date of Service To': PropTypes.string,
    'Date of Creation From': PropTypes.string,
    'Date of Creation To': PropTypes.string,
    'Workflow State': PropTypes.arrayOf(PropTypes.string),
    'Workflow Status': PropTypes.arrayOf(PropTypes.string),
    'Report Order Line Type': PropTypes.arrayOf(PropTypes.string),
  }),
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    gridButtons: PropTypes.string.isRequired,
    gridItemShrink: PropTypes.string.isRequired,
    gridError: PropTypes.string.isRequired,
  }).isRequired,
  onReportGenerate: PropTypes.func.isRequired,
};

ReportsCreateEditFormMain.defaultProps = {
  initialValues: {},
  filters: {},
};

export default withStyles(styles)(ReportsCreateEditFormMain);



// WEBPACK FOOTER //
// ./src/components/reports/ReportsCreateEditForm/ReportsCreateEditFormMain.js